"use client"

import NextError from "next/error"
import posthog from "posthog-js"
import { useEffect } from "react"

type GlobalErrorProps = {
  error: Error & { digest?: string }
}

export default function GlobalError({ error }: GlobalErrorProps) {
  useEffect(() => {
    // PostHog only initialises inside /logged-in, so on a public page there is
    // no client to report to and the call would just warn. Errors outside the
    // product surface through the server logs instead.
    if (!posthog.__loaded) return
    posthog.captureException(error)
  }, [error])

  return (
    <html>
      <body>
        <NextError statusCode={0} />
      </body>
    </html>
  )
}
